import React from "react";
import {
  Layout,
  Input,
  Button,
  Row,
  Col,
  Typography,
  Spin,
  message,
  Tooltip,
  Modal,
  Table,
} from "antd";
import Top from "../../components/common/Top";
import Footer from "../../components/common/Footer";
import "./index.scss";

import { connect } from "react-redux";
import { getFilesList } from "../../utils/api";

import InfoDetail from "../../components/common/InfoDetail";
const workGuideList = [
  {
    title: "申请条件",
    url: "apply",
    type: 2,
  },
  {
    title: "租赁指南",
    url: "guide",
    type: 3,
  },
  {
    title: "资料下载",
    url: "download",
    type: 4,
  },
  {
    title: "常见问题",
    url: "faq",
    type: 5,
  },
];

class WorkGuide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      loading: false,
      selectedGuide: {},
      detailInfo: {},
      pagination: {
        current: 1,
        pageSize: 10,
      },
    };
  }

  componentDidMount() {
    this.setState(
      {
        selectedGuide:
          workGuideList.find(
            (v) => v.url === this.props.location.query?.type
          ) || workGuideList[0],
      },
      () => {
        this.fetchData();
      }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.globeParams?.workGuide !== this.state.selectedGuide.url) {
      this.setState(
        {
          selectedGuide:
            workGuideList.find(
              (v) => v.url === nextProps.globeParams?.workGuide
            ) || workGuideList[0],
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   console.log(1, prevState.selectedGuide);
  //   console.log(2, this.state.selectedGuide);
  //   if (this.state.selectedGuide?.url !== prevState.selectedGuide?.url) {
  //     this.fetchData();
  //   }
  // }

  // static getDerivedStateFromProps(props, state) {
  //   console.log(3, props.globeParams?.workGuide);
  //   if (props.globeParams?.workGuide) {
  //     return {
  //       selectedGuide: workGuideList.find(
  //         (v) => v.url === props.globeParams?.workGuide
  //       ),
  //     };
  //   }

  //   return state;
  // }

  onChange = (pagination, filters, sorter) => {
    this.setState(
      {
        pagination,
      },
      () => {
        this.fetchData();
      }
    );
  };

  fetchData = async () => {
    const { pagination, selectedGuide } = this.state;
    this.setState({
      loading: true,
    });
    const params = {
      type: selectedGuide.type,
      pageIndex: pagination.current - 1 || 0,
      pageSize: pagination.pageSize || 10,
    };
    const res = await getFilesList(params);
    if (res.code === 0) {
      this.setState({
        dataSource: res.data,
        loading: false,
        pagination: {
          ...pagination,
          total: res.data.count,
        },
      });
    }
  };

  changeGuilde = (v) => {
    this.setState(
      {
        selectedGuide: v,
        detailInfo: {},
        pagination: {
          current: 1,
          pageSize: 10,
        },
      },
      () => {
        this.fetchData();
      }
    );
  };

  goDetail = (row) => {
    const { selectedGuide } = this.state;
    if (selectedGuide.url === "download") return false;
    this.setState({
      detailInfo: {
        ...row,
        name: selectedGuide.title,
      },
    });
  };

  goBack = () => {
    this.setState({
      detailInfo: {},
    });
  };

  render() {
    const { dataSource, loading, selectedGuide, detailInfo, pagination } =
      this.state;
    const columns = {
      commonColumns: [
        {
          title: "信息名称",
          dataIndex: "title",
          key: "title",
          ellipsis: true,
        },

        {
          title: "发布日期",
          dataIndex: "publicTime",
          key: "publicTime",
          width: 200,
        },
      ],
      download: [
        {
          title: "文件名称",
          dataIndex: "title",
          key: "title",
          ellipsis: true,
        },

        {
          title: "文件下载",
          dataIndex: "action",
          key: "action",
          width: 200,
          render: (text, record) => (
            <a
              href="javasctipt:void(0)"
              onClick={() => window.open(record.content)}
            >
              下载
            </a>
          ),
        },
      ],
    };

    return (
      <Layout style={{ minHeight: "100%", minWidth: "100%" }} id="policyPage">
        <Top />
        <Layout>
          <Row>
            <div className="col-lg-2"></div>
            <div className="col-lg-8 col-xs-12">
              {detailInfo.id ? (
                <InfoDetail goBack={this.goBack} info={this.state.detailInfo} />
              ) : (
                <div className="workguide">
                  <div className="left">
                    <div className="guide-title">办事指南</div>
                    <div style={{ marginTop: 10 }}>
                      {workGuideList.map((v) => (
                        <div
                          key={v.title}
                          className={
                            selectedGuide.title === v.title
                              ? "guide-content active"
                              : "guide-content"
                          }
                          onClick={() => this.changeGuilde(v)}
                        >
                          {v.title}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="right">
                    <div
                      style={{
                        margin: "30px 0",
                        borderBottom: "1px solid #0263ac",
                      }}
                    >
                      <div
                        style={{
                          color: "#fff",
                          background: "#0263ac",
                          display: "inline-block",
                          padding: "10px 30px",
                          fontSize: 20,
                        }}
                      >
                        {selectedGuide?.title || "办事指南"}
                      </div>
                    </div>
                    <div>
                      <Table
                        rowKey="id"
                        columns={
                          selectedGuide.url === "download"
                            ? columns.download
                            : columns.commonColumns
                        }
                        dataSource={dataSource?.pageContent}
                        pagination={pagination}
                        rowClassName="editable-row"
                        onChange={this.onChange}
                        loading={loading}
                        onRow={(record) => {
                          return {
                            onClick: (event) => {
                              this.goDetail(record);
                            }, // 点击行
                          };
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-2"></div>
          </Row>
        </Layout>
        {/* <Footer /> */}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
    globeParams: state.globeParams,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkGuide);
